export default {
  choose_an_option: 'Choisir une option:',
  choose_an_option_is_formal: 'Choisir une option:',
  select_options: 'Sélectionnez les options',
  select_options_is_formal: 'Sélectionnez les options',
  enter_text_here: 'Saisissez votre texte ici',
  redirect_counter_message:
    'Je vous redirige vers notre site web dans {{counter}} secondes',
  redirect_counter_message_is_formal:
    'Je vous redirige vers notre site web dans {{counter}} secondes',
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano',
  whatsapp: 'WhatsApp',
  sms: 'SMS /iMessage',
  email: 'E-Mail',
  nps_scale_meaning: '0 = peu probable / 10 = très probable',
  please_provide_answers_to_both_questions:
    'Veuillez répondre aux deux questions',
  please_answer_the_first_question: 'Veuillez répondre à la première question',
  please_answer_the_second_question: 'Veuillez répondre à la deuxième question',
  answer_at_least_one_question: 'Veuillez répondre à au moins une question',
  selection: 'Sélection',
  answer: 'Réponse',
  share_api_option_text: 'Choisir une application',
  share_status_SHARE: 'Partagé',
  share_status_CANCEL: 'Partage annulé',
  language_nav_label: 'Sélection de la langue',
  OPENS_IN_NEW_TAB: "s'ouvre dans un nouvel onglet",
  nps_rating_aria: 'Note',
  language_switcher_aria: 'Choisir la langue',
  company_logo_aria: "Logo de l'entreprise (s'ouvre dans un nouvel onglet)",
  powered_by_hypt_aria: "Powered by HYPT (s'ouvre dans un nouvel onglet)",
  employee_search_placeholder: 'Rechercher...',
  employee_search_aria: 'Rechercher un employé',
  loading_aria: 'Chargement',
  chat_messages_aria: 'Messages du chat',
  skip_to_content: 'Aller au contenu',
  company_logo_alt: "Logo de l'entreprise",
  ai_feedback_input_aria: 'Saisissez votre avis',
  error_funnel_not_published: 'Questionnaire pas encore publié',
  error_funnel_not_found: "Ce questionnaire n'existe pas",
  error_funnel_come_back_later:
    'Veuillez revenir plus tard. Nous apprécions votre patience.',
  error_404: 'ERREUR 404',
  error_page_not_found: 'PAGE NON TROUVÉE',
  chat_history_aria: 'Historique du chat',
  checkbox_required_sr: 'au moins une sélection requise',
  ai_answer_required_hint: 'Saisissez votre avis pour continuer'
};
